/*
  <rr-carousel> — native scroll-snap carousel with prev/next buttons, shared by every rr26 carousel section.

  Markup:
    <rr-carousel>
      <ul data-rr-track> <li data-rr-slide>…</li> … </ul>
      <button data-rr-prev>…</button> <button data-rr-next>…</button>
    </rr-carousel>

  Swiping and trackpads work natively; the buttons scroll by one slide. A button is disabled when
  there is nothing further in its direction (the design's white "inactive" arrow).
*/
class RrCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-rr-track]');
    this.prev = this.querySelector('[data-rr-prev]');
    this.next = this.querySelector('[data-rr-next]');
    if (!this.track) return;

    this.update = this.update.bind(this);
    this.prev?.addEventListener('click', () => this.step(-1));
    this.next?.addEventListener('click', () => this.step(1));
    this.track.addEventListener('scroll', this.update, { passive: true });
    this.resizeObserver = new ResizeObserver(this.update);
    this.resizeObserver.observe(this.track);
    this.update();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
  }

  step(direction) {
    const slide = this.track.querySelector('[data-rr-slide]');
    if (!slide) return;
    // Layout px (offsetWidth), not getBoundingClientRect: under CSS zoom/transforms the rect is scaled while
    // scrollBy is not, which made one click skip two slides.
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    this.track.scrollBy({ left: direction * (slide.offsetWidth + gap), behavior: 'smooth' });
  }

  update() {
    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    const atStart = scrollLeft <= 1;
    const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;
    if (this.prev) this.prev.disabled = atStart;
    if (this.next) this.next.disabled = atEnd;
    this.toggleAttribute('data-static', atStart && atEnd);
  }
}

if (!customElements.get('rr-carousel')) customElements.define('rr-carousel', RrCarousel);
